import React from 'react';
import Colors from '../styles/colors';

import { makeStyles } from '@material-ui/styles';
import ErrorComponent from '../components/errorComponent';
import BottomNav from '../components/bottomNav';

const ErrorPage = React.memo(() => {

  //Styles for this component
  const style = makeStyles({
    fullHeight: {
      backgroundColor: Colors.white,
      paddingBottom: 100,
      height: '100%',
      overflow: 'scroll',
    },
  });

  const styles=style();

  return (
    <div className={styles.fullHeight}>
      <ErrorComponent message="Uh oh! Looks like you found a page that doesn't exit." />
      <BottomNav />
    </div>
  );
});

export default ErrorPage;
